import { render, staticRenderFns } from "./CoparticipationTable.vue?vue&type=template&id=2a82e0a4&"
import script from "./CoparticipationTable.vue?vue&type=script&lang=js&"
export * from "./CoparticipationTable.vue?vue&type=script&lang=js&"
import style0 from "./CoparticipationTable.vue?vue&type=style&index=0&id=2a82e0a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports